<!--============================
=            LOADER            =
=============================-->
<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Loader</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Example</div>
          <div slot="card-body">
            <v-sheet
              :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
              class="px-3 pt-3 pb-3"
            >
              <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2 pl-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <v-sheet
              :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
              class="px-3 pt-3 pb-12"
            >
              <v-responsive :max-width="type.indexOf('table') > -1 ? 900 : 500" class="mx-auto">
                <v-responsive class="mx-auto mb-12" max-width="500">
                  <div class="d-flex pa-3 align-center flex-wrap">
                    <v-select
                      v-model="type"
                      :items="types"
                      class="mr-12"
                      hide-details
                      label="Pre-made Types"
                      filled
                      style="max-width: 250px;"
                    ></v-select>
                    <div>
                      <v-switch v-model="boilerplate" inset hide-details label="Boilerplate"></v-switch>
                      <v-switch v-model="tile" inset hide-details label="Tile"></v-switch>
                    </div>
                  </div>
                </v-responsive>
                <v-skeleton-loader
                  ref="skeleton"
                  :boilerplate="boilerplate"
                  :type="type"
                  :tile="tile"
                  class="mx-auto"
                ></v-skeleton-loader>
              </v-responsive>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2 pr-2">
          <div slot="card-header">Implementation methods</div>
          <div slot="card-body">
            <v-sheet
              :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
              class="px-3 pt-3 pb-12"
            >
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-boilerplate class="mb-6" type="card-avatar, article, actions"></v-boilerplate>
                    <v-boilerplate type="date-picker"></v-boilerplate>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-boilerplate class="mb-6" type="article, actions"></v-boilerplate>
                    <v-boilerplate
                      class="mb-6"
                      type="table-heading, list-item-two-line, image, table-tfoot"
                    ></v-boilerplate>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-boilerplate
                      class="mb-6"
                      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                    ></v-boilerplate>
                    <v-boilerplate type="list-item-avatar-three-line, image, article"></v-boilerplate>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Accessibility</div>
          <div slot="card-body">
            <v-container class="grey">
              <div class="text-center d-flex justify-center align-center mb-12 flex-wrap">
                <v-btn class="mx-12 my-4" @click="loading = !loading">Toggle</v-btn>
                <v-select
                  v-model="transition"
                  label="Transition"
                  hide-details
                  :items="transitions"
                  style="max-width: 200px;"
                ></v-select>
              </div>
              <v-row justify="center">
                <v-col class="text-center" cols="12">
                  <div class="headline">Default Slot</div>
                </v-col>
                <v-col class="mb-12" cols="12" md="4">
                  <v-skeleton-loader
                    :loading="loading"
                    :transition="transition"
                    height="94"
                    type="list-item-two-line"
                  >
                    <v-card>
                      <v-card-title>Title</v-card-title>
                      <v-card-text>Card Text</v-card-text>
                    </v-card>
                  </v-skeleton-loader>
                </v-col>
                <v-col class="text-center" cols="12">
                  <div class="headline">
                    If conditional
                    <br />w/Transition Element
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <component :is="transition !== 'None' ? `v-${transition}` : 'div'" hide-on-leave>
                    <v-skeleton-loader v-if="loading" height="94" type="list-item-two-line"></v-skeleton-loader>
                    <v-card v-else>
                      <v-card-title>Title</v-card-title>
                      <v-card-text>Card Text</v-card-text>
                    </v-card>
                  </component>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  inject: ["theme"],
  data: () => ({
    boilerplate: false,
    tile: false,
    type: "list-item-avatar-three-line",
    types: [],
    loading: true,
    transition: "scale-transition",
    transitions: [
      {
        text: "None",
        value: undefined
      },
      {
        text: "Fade Transition",
        value: "fade-transition"
      },
      {
        text: "Scale Transition",
        value: "scale-transition"
      }
    ]
  }),

  mounted() {
    this.types = Object.keys(this.$refs.skeleton.rootTypes);
  }
};
</script>
<!--====  End of LOADER  ====-->